import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getReportingManagerListing = async (payload) => {
	let response = null;
	let errorMessage = null;

	try {
		const res = await api.get.employee.reportingManagerList();
		const keyword = (payload?.keyword || "").toLowerCase();
		const content = res.map(({ name, id, ...o }) => ({ ...o, label: name, value: id })).filter((o) => o.label?.toLowerCase().includes(keyword));
		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getReportingManagerListing;
